import { render } from "./zyjs.vue?vue&type=template&id=13ff2fbc&scoped=true&ts=true"
import script from "./zyjs.vue?vue&type=script&lang=ts"
export * from "./zyjs.vue?vue&type=script&lang=ts"

import "./zyjs.vue?vue&type=style&index=0&id=13ff2fbc&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ff2fbc"]])

export default __exports__